<template>
  <div
    class="px-1 py-5 text-subtitle-1"
    :class="{sticky:isSticky}"
    :style="{ 'backgroundColor': theme.backgroundColor, 'color': theme.textColor }"
  >
    <v-icon v-if="icon" class="pr-2" :color="theme.textColor">{{icon}}</v-icon>
    {{message}}
  </div>
</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin';

export default {
  name: 'InfoMessage',
  mixins: [layoutMixin],
  props: {
    message: { type: String, default: '' },
    icon: { type: String, default: '' },
    isSticky: { type: Boolean, default: false },
    backgroundColor: { type: String, default: '' },
    textColor: { type: String, default: '' },
    iconColor: { type: String, default: '' },
  }
}
</script>

<style scoped>
  .sticky{
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
  }
</style>
